export enum AccessModals {
	SuccessfulScan = 'SuccessfulScan',
	ManuallyEntry = 'ManuallyEntry',
	ManuallyExit = 'ManuallyExit',
	OutOfDateEntry = 'OutOfDateEntry',
	OutOfDateExit = 'OutOfDateExit',
	OfflineScanning = 'OfflineScanning',
	InvalidScan = 'InvalidScan',
}
